{
  "WALLBOARD": {
    "LOADING": "Chargement des files d'attente téléphoniques...",
    "NO_QUEUES": "Aucune file d'attente téléphonique trouvée.",
    "AGENTS": "Agents",
    "NO_AGENTS": "Aucun agent en ligne dans cette file d'attente.",
    "NO_AGENTS_ONLINE": "Aucun agent en ligne.",
    "WAITING_CALLERS": "Appelants en attente",
    "NO_CALLERS": "Aucun appelant en attente.",
    "UNKNOWN_CALLER": "Appelant inconnu",
    "POSITION": "Position",
    "STATUS": "Statut",
    "TIME": "Durée",
    "AGENT": "Agent",
    "EXTENSION": "Extension",
    "AVAILABLE": "Disponible",
    "READY": "Agents prêts",
    "ON_CALL": "Agents en appel",
    "QUEUE_CALL": "Appel de file d'attente",
    "OTHER_CALL": "Autre appel",
    "PAUSED": "Agents en pause",
    "WAITING": "Appels en attente",
    "MISSED_CALLS": "Appels manqués",
    "HANDLED_CALLS": "Appels entrants traités",
    "OUTBOUND_CALLS": "Appels sortants traités",
    "AVAILABILITY": "Disponibilité",
    "AVAILABILITY_TOOLTIP": "Pourcentage d'appels entrants répondus par les agents (appels qui ont été décrochés)",
    "TOTAL": "total",
    "AGENTS_COUNT": "({onCall} en appel / {total} au total)",
    "NO_AVAILABLE": "(personne en ligne)",
    "WAITING_CALLERS_COUNT": "{count} en attente",
    "CALLER": "Appelant",
    "NUMBER": "Numéro",
    "WAIT_TIME": "Temps d'attente",
    "QUEUES": "Files d'attente",
    "ACTION": "Action",
    "PICKUP_CALL": "Prendre l'appel",
    "PICKING_UP": "Prise de l'appel...",
    "PICKUP_SUCCESS": "Prise d'appel demandée avec succès.",
    "PICKUP_ERROR": "Impossible de prendre l'appel. Veuillez réessayer.",
    "PICKUP_DISABLED_TOOLTIP": "Vous ne pouvez pas prendre un appel lorsque vous êtes en appel ou hors ligne.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Pas d'accès"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Pas d'accès"
    }
  }
}
